import { Pipe, PipeTransform } from '@angular/core';

interface Option {
  value: unknown;
  label: string;
}

/**
 * Resolve o rótulo de uma opção pelo valor: `{{ ad.state | optionLabel: states }}`.
 *
 * Existe para tirar do template chamadas como `showCurrentState(ad)`, que rodavam a cada
 * ciclo de detecção de mudança — e, dentro de um `*ngFor`, uma vez por item.
 */
@Pipe({ name: 'optionLabel' })
export class OptionLabelPipe implements PipeTransform {
  transform(value: unknown, options: Option[] | null | undefined): string {
    return options?.find(o => o.value === value)?.label || '';
  }
}
